import { State } from '@meraki-internal/state';
import { MixPanelEventEmitter as MixpanelService } from '../metrics/MixPanelEventEmitter';
import { BufferedEventBus } from '../utils/BufferedEventBus';

export type IConnectCalendarTrackingFrom = 'care map settings' | 'appointments settings' | 'empty appointments' | 'first appointment';
export class ConnectCalendarViewModel extends State<Record<string, never>> {

    private _isOpen = false;

    static inject = () => [BufferedEventBus, MixpanelService];

    constructor(
        private events: BufferedEventBus,
        private tracking: MixpanelService
    ) {
        super({ });

        // after the user adds their "first" appointment, show the connect dialog
        this.events.on(
            'AppointmentsState.appointmentAdded',
            (payload?: {appointmentCount: number}) => {
                // used by tests to avoid triggering this when it isn't the focus of the test
                if (this.disableModal){
                    return;
                }
                if (payload?.appointmentCount === 1) {
                    setTimeout(() => this.open('first appointment'), 750);
                }
            }
        );
    };

    isOpen = () => this._isOpen;

    open = (from: IConnectCalendarTrackingFrom) => {
        this.tracking.track('Connect Calendar Modal Opened', () => ({ from }));

        this._isOpen = true;
        this.setState({ });
    };

    close = () => {
        this._isOpen = false;
        this.setState({ });
    };

    disableModal = false;
}
